import { AppPageComponent } from './app-page/app-page.component';
import { authPages } from './auth';

export * from './app-page/app-page.component';

export const pages = [AppPageComponent, ...authPages];
